module.exports = __webpack_public_path__ + "static/media/pulsidM.fd84646a.webp";